import React from "react";
import Herbicide from "./Herbicide";

function page(){
    return(

        <>
        <Herbicide />
        </>

    );
}
export default page;